import { EuiHorizontalRule, EuiSpacer } from "@elastic/eui";
import React from "react";

import ProfileDetailsBody from "./ProfileDetailsBody";
import ProfileDetailsHeader from "./ProfileDetailsHeader";

import * as S from "./style";

function ProfileDetails() {
    return (
        <S.ProfileDetailsWrapper paddingSize="none">
            <ProfileDetailsHeader />

            <EuiHorizontalRule margin="none" />

            <ProfileDetailsBody />

            <EuiSpacer size="s" />
        </S.ProfileDetailsWrapper>
    );
}

export default ProfileDetails;
